import { formatTime, formatDate } from '@smarttransit/common'
import { maskPhoneNumber } from '@smarttransit/common-client'
import { isAuthorized, addAlert } from '../../../../utilities/helpers'
import { countPhoneBlacklist, findPhoneBlacklist } from '../../../../services/phone-blacklist-service'

export default {
  props: {
    signedInUser: Object
  },
  data () {
    return {
      name: 'passengers-phone-blacklist',
      apiInProgress: false,
      isAdmin: false,
      searchKeywords: '',
      headers: [
        { text: 'Phone', value: 'phoneNumber' },
        { text: 'Threat level', value: 'threatLevelLabel' },
        { text: 'Date created', value: 'dateCreated' },
        { text: 'Date updated', value: 'dateUpdated' },
        { text: 'Date restored', value: 'dateRestored' },
        { text: '', value: 'actions', sortable: false }
      ],
      records: [],
      total: 0,
      pagination: { sortBy: 'dateUpdated', descending: true, rowsPerPage: 25 }
    }
  },
  watch: {
    $route () {
      this.refresh(1)
    }
  },
  mounted () {
    this.isAdmin = isAuthorized(this.$props.signedInUser, 'admin')
    this.refresh()
  },
  methods: {
    isListRouteActive () {
      return this.$router && this.$router.currentRoute && this.$router.currentRoute.name === 'passengers-phone-blacklist'
    },
    async refresh (setPage) {
      if (!this.isListRouteActive()) {
        return
      }

      this.apiInProgress = true

      try {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const offset = (setPage || page || 1) === 1 ? 0 : ((setPage || page) * rowsPerPage) - rowsPerPage
        const limit = rowsPerPage
        const order = sortBy ? `${sortBy} ${descending ? 'DESC' : 'ASC'}` : 'dateUpdated DESC'

        const keywords = String(this.searchKeywords || '').trim()

        const [items, totalResult] = await Promise.all([
          findPhoneBlacklist({ keywords, limit, offset, order }),
          countPhoneBlacklist({ keywords })
        ])

        this.records = Array.isArray(items) ? items : []
        this.records = this.records.map(record => ({
          ...record,
          threatLevelLabel: record.threatLevel === 2 ? 'High Risk' : 'Suspicious',
          dateCreatedLabel: `${formatTime(record.dateCreated)}, ${formatDate(record.dateCreated)}`,
          dateUpdatedLabel: `${formatTime(record.dateUpdated)}, ${formatDate(record.dateUpdated)}`,
          dateRestoredLabel: record.dateRestored ? `${formatTime(record.dateRestored)}, ${formatDate(record.dateRestored)}` : '-',
          phoneNumberLabel: maskPhoneNumber(record.phoneNumber, this.$store.getters.phoneNumberCountryCodes)
        }))

        this.total = totalResult && totalResult.count ? totalResult.count : 0
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        this.apiInProgress = false
      }
    },
    onPagination () {
      this.refresh()
    },
    openNew () {
      this.$router.push({ name: 'passengers-phone-blacklist-phone', params: { phoneBlacklistId: '0' } })
    },
    openRecord (record) {
      this.$router.push({ name: 'passengers-phone-blacklist-phone', params: { phoneBlacklistId: record.id } })
    }
  }
}
